import { H5 } from 'components/headings';
import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: ${rem(16)};
`;

export const PlanTitle = styled(H5)`
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.palette.black};
`;

export const AlertWrapper = styled.div`
  margin-bottom: 16px;
`;

export const AccountPlanWrapper = styled.div`
  padding: ${rem(24)};
  background: rgba(255, 255, 255, 0.4);
  border-radius: 40px;
`;
